import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, MemoryRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import SkiPasses from './pages/SkiPasses';
import AddSkiPass from './pages/AddSkiPass';
import PricingPageSimple from './pages/PricingPageSimple';
import PaymentResult from './pages/PaymentResult';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import './styles/main.scss';
import './styles/form.css';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return <div style={{ padding: '2rem', textAlign: 'center' }}>Loading...</div>;
  }
  
  return isAuthenticated ? children : <Navigate to="/admin/login" />;
};

const WebComponentRoutes = () => {
  const [confirmationOrderId, setConfirmationOrderId] = useState(null);
  
  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data && event.data.type === 'show-confirmation') {
        const orderId = event.data.orderId;
        if (orderId) {
          setConfirmationOrderId(orderId);
        }
      }
    };
    
    window.addEventListener('message', handleMessage);
    
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);
  
  const handleReturnHome = () => {
    setConfirmationOrderId(null);
  };
  
  if (confirmationOrderId) {
    return <PaymentResult orderId={confirmationOrderId} onReturnHome={handleReturnHome} embedded={true} />;
  }
  
  return <PricingPageSimple />;
};

function App() {
  const basename = window.__SKI_PASS_BASENAME__ || '';
  const isWebComponent = window.__SKI_PASS_WEB_COMPONENT__ || false;
  const initialRoute = window.__SKI_PASS_INITIAL_ROUTE__ || '/';
  
  const RouterComponent = isWebComponent ? MemoryRouter : Router;
  const routerProps = isWebComponent 
    ? { initialEntries: [initialRoute], initialIndex: 0 }
    : { basename };
  
  console.log('App component rendering:', {
    basename,
    isWebComponent,
    initialRoute,
    location: window.location.pathname,
    RouterComponent: RouterComponent.name
  });
  
  return (
    <AuthProvider>
    <RouterComponent {...routerProps}>
      <div className="skipass-App">
        <main className="skipass-App">
          {isWebComponent ? (
            <WebComponentRoutes />
          ) : (
            <Routes>
              <Route path="/" element={<PricingPageSimple />} />
              <Route path="/payment-result" element={<PaymentResult />} />
              <Route path="/passes" element={<SkiPasses />} />
              <Route path="/add" element={<AddSkiPass />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
            </Routes>
          )}
        </main>
      </div>
    </RouterComponent>
    </AuthProvider>
  );
}

export default App;
